import React from "react";

// Kit switch (styles: src/styles/ui-kit.css .inyc-switch): an on/off setting that applies right away.
// Controlled: value + onChange(next). The native checkbox stays focusable (keyboard: space).
const Switch = ({ value = false, onChange, label, disabled = false, className = "" }) => (
  <label className={`inyc-switch ${className}`.trim()}>
    <input
      type="checkbox"
      role="switch"
      className="inyc-switch-input"
      checked={Boolean(value)}
      disabled={disabled}
      aria-label={label}
      onChange={(e) => onChange?.(e.target.checked)}
    />
    <span className="inyc-switch-track" aria-hidden="true" />
  </label>
);

export default Switch;
